import { useRef, useState } from 'react'

import { IconSearch } from '@tabler/icons-react'
import { Input, Space } from 'antd'
import Highlighter from 'react-highlight-words'

import { Button } from '@/components/shared-components/BUI/Button'
import TableLink from '@/components/shared-components/TableLink'

import { buildPassTheme } from 'src/styles/theme'

export const useColumnSearch = () => {
  const [searchText, setSearchText] = useState([])
  const [searchColumn, setSearchColumn] = useState([])
  const inputRef = useRef(null)

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()
    setSearchText(selectedKeys[0])
    setSearchColumn(dataIndex)
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const MaybeLink = ({ onClick, children }) => {
    if (onClick) {
      return <TableLink onClick={onClick}>{children}</TableLink>
    }
    return children
  }

  const getColumnSearchProps = (dataIndex, onClick = null) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={inputRef}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            variant="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<IconSearch size={16} />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <IconSearch
        size={16}
        style={{
          color: filtered ? buildPassTheme.colour.link.base : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => inputRef.current.select())
      }
    },
    render: (text, record) => (
      <MaybeLink onClick={onClick ? () => onClick(record) : null}>
        {searchColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: buildPassTheme.colour.semantic.warning,
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          <>{text}</>
        )}
      </MaybeLink>
    ),
  })

  return getColumnSearchProps
}

export default useColumnSearch
